module.exports = __webpack_public_path__ + "img/mangomolo.da79e2e5.png";